import { useMemo } from "react";
import { decode } from "html-entities";

type Props = {
  name: string;
};

export function HotelName({ name }: Props) {
  const decodedName = useMemo(() => {
    return decode(name).toLocaleLowerCase();
  }, [name]);

  return decodedName ? <span className="capitalize">{decodedName}</span> : null;
}
